import { atom } from 'jotai';

/**
 * Current conversation ID - synced with URL route parameter
 *
 * Set when navigating to /conversation/[id]
 * Null when on /new page
 *
 * Note: To check if messages are loaded, use TanStack Query cache:
 * `useMessagesCache().hasMessages(id)`
 */
export const currentConversationIdAtom = atom<string | null>(null);

/**
 * Reset conversation state (for logout)
 */
export const resetConversationStateAtom = atom(null, (_get, set) => {
	set(currentConversationIdAtom, null);
});
